interface StatCardProps {
  icon?: React.ReactNode
  title: string
  value: string | number
  onClick?: () => void
  iconBgColor?: string
  iconColor?: string
  subtitle?: string
  trend?: string
}

export function StatCard({
  icon,
  title,
  value,
  onClick,
}: StatCardProps) {
  return (
    <div
      onClick={onClick}
      className='bg-[rgba(237,239,243,0.44)] flex flex-col justify-between rounded-2xl p-4 relative cursor-pointer hover:bg-[rgba(237,239,243,0.6)] transition-colors h-[123px]'
    >
      <div className='flex items-center justify-start gap-6'>
        {/* Icon box with orange border */}
      {icon && (
        <div className='w-[30px] h-[29px] border-2 border-[#FF6600] rounded-[7px] flex items-center justify-center overflow-hidden mb-2'>
          <div className='w-6 h-6 text-[#FF6600]'>{icon}</div>
        </div>
      )}

      {/* Title */}
      <p className='font-bold text-[#434343] text-[16px] leading-6 mb-1'>{title}</p>
      </div>

      <div className='flex items-center justify-between'>
        {/* Value */}
        <p className='font-bold text-[#151515] text-[30px] leading-8'>{value}</p>

        {/* Arrow indicator at bottom right */}
        <div className=''>
          <svg width='16' height='16' viewBox='0 0 5 9' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M1 1L4 4.5L1 8' stroke='#6C6C6C' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
      </div>
    </div>
  )
}
